import { Pipe, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// Regular expression to find <a> tags
const anchorRegex = /<a\s+([^>]*?)>/gi;

@Pipe({ name: 'targetBlank' })
export class TargetBlankPipe {
    constructor(private sanitizer: DomSanitizer) {}

    /**
     * If a URL within a string provided by the API is already inside an <a> element the auto-linker won't
     * add a blank target to it.
     *
     * This pipe will catch any of these links that fall through by adding target="_blank" to the element properties if missing.
     *
     * The input type can be both string or SafeHtml, meaning this pipe can be used on its own, or in conjunction with
     * the auto link pipe, in which case the auto link pipe should be added first in the pipe chain (e.g. "someText | autolink | targetBlank")
     */
    transform(text: string | SafeHtml): string | SafeHtml {
        if (text == null) {
            return text;
        }

        // Convert SafeHtml to string for processing
        const textString =
            typeof text === 'string'
                ? text
                : this.sanitizer.sanitize(SecurityContext.HTML, text);

        const processedText = textString.replace(
            anchorRegex,
            (match, attributes) => {
                // Check if any target attribute exists
                const targetRegex = /target\s*=\s*["'][^"']*["']/i;

                let updatedAttributes = attributes.trim();
                const targetAttribute = 'target="_blank"';

                if (targetRegex.test(attributes)) {
                    // Replace existing target attribute with target="_blank"
                    updatedAttributes = updatedAttributes.replace(
                        targetRegex,
                        targetAttribute
                    );
                    return `<a ${updatedAttributes}>`;
                } else {
                    // Add target="_blank" to the attributes
                    if (updatedAttributes) {
                        return `<a ${updatedAttributes} ${targetAttribute}>`;
                    } else {
                        return `<a ${targetAttribute}>`;
                    }
                }
            }
        );

        // If input was SafeHtml, return as SafeHtml; otherwise return as string
        return typeof text === 'string'
            ? processedText
            : this.sanitizer.bypassSecurityTrustHtml(processedText);
    }
}
